/**
 * 日本の学年計算ユーティリティ
 * 生まれ年・月 → 学年ラベルを返す
 */

/**
 * 入学年度を計算
 * 日本では4月2日以降生まれが翌年度入学のため、
 * 月だけで近似: 1〜3月→birth_year+6, 4〜12月→birth_year+7
 */
export function getEntranceYear(birthYear, birthMonth) {
  return birthMonth <= 3 ? birthYear + 6 : birthYear + 7;
}

/**
 * 現在の学年番号を返す
 * 1=小1, 2=小2, ..., 6=小6, 7=中1, ..., 9=中3
 * 0=年長, -1=年中, -2=年少, -3以下=乳幼児
 */
export function getGradeNumber(birthYear, birthMonth) {
  const y = parseInt(birthYear);
  const m = parseInt(birthMonth);
  if (!y || !m || isNaN(y) || isNaN(m)) return null; // 未設定・不正値はnullを返す
  const today = new Date();
  const currentYear  = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // 1〜12
  const currentSchoolYear = currentMonth >= 4 ? currentYear : currentYear - 1;
  const entranceYear = getEntranceYear(y, m);
  return currentSchoolYear - entranceYear + 1;
}

/**
 * 学年ラベルを返す（表示用）
 * 例: "小2", "年長", "中1"
 */
export function getGradeLabel(birthYear, birthMonth) {
  if (!birthYear || !birthMonth) return '';
  const grade = getGradeNumber(birthYear, birthMonth);
  if (grade <= -3) return '乳幼児';
  if (grade === -2) return '年少';
  if (grade === -1) return '年中';
  if (grade === 0)  return '年長';
  if (grade >= 1 && grade <= 6) return `小${grade}`;
  if (grade === 7)  return '中1';
  if (grade === 8)  return '中2';
  if (grade === 9)  return '中3';
  return '中学生以上';
}

/**
 * 学年に合わせたおすすめメッセージ
 */
export function getGradeRecommendation(birthYear, birthMonth) {
  if (!birthYear || !birthMonth) return null;
  const grade = getGradeNumber(birthYear, birthMonth);
  if (grade <= 0)  return { label: '未就学児向け', hint: '短い詩やわらべうたがおすすめ！' };
  if (grade <= 2)  return { label: '小1・2年生向け', hint: 'ひらがなの多いやさしいテキストがおすすめ！' };
  if (grade <= 4)  return { label: '小3・4年生向け', hint: '少し長い文章にもチャレンジしよう！' };
  return { label: '小5・6年生以上向け', hint: '難しい文章にもチャレンジしよう！' };
}

/** 生年月のプルダウン用: 年リスト（未就学〜中3を想定） */
export function getBirthYearOptions() {
  const currentYear = new Date().getFullYear();
  const years = [];
  // 中3（15歳）〜 乳児（1歳）くらいまで
  for (let y = currentYear - 15; y <= currentYear - 1; y++) {
    years.push(y);
  }
  return years.reverse(); // 新しい年が上
}

export const MONTH_OPTIONS = [1,2,3,4,5,6,7,8,9,10,11,12];
